var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusWhite = function SvgPlusWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.25 10.5H13.5V3.75a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v6.75H3.75a.75.75 0 0 0-.75.75v1.5c0 .414.336.75.75.75h6.75v6.75c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75V13.5h6.75a.75.75 0 0 0 .75-.75v-1.5a.75.75 0 0 0-.75-.75"
  })));
};
export default SvgPlusWhite;